import InputField from "./InputField";
import { useAmount } from "../contexts/amountContext";

const Accessory = () => {
  const { accessory, handleAccessoryChange } = useAmount();
  return (
    <div className="col text-center">
      <h1>Accessory</h1>

      <InputField
        lable="Grocery"
        id="groceryMarket"
        name="groceryMarket"
        value={accessory.groceryMarket}
        onChange={handleAccessoryChange}
      />

      <InputField
        lable="Wifi bill"
        id="wifi"
        name="wifi"
        value={accessory.wifi}
        onChange={handleAccessoryChange}
      />

      <InputField
        lable="Electricity bill"
        id="electricity"
        name="electricity"
        value={accessory.electricity}
        onChange={handleAccessoryChange}
      />

      <InputField
        lable="Gas bill"
        id="gas"
        name="gas"
        value={accessory.gas}
        onChange={handleAccessoryChange}
      />

      <InputField
        lable="House Rent"
        id="houseRent"
        name="houseRent"
        value={accessory.houseRent}
        onChange={handleAccessoryChange}
      />

      <InputField
        lable="Cooker salary"
        id="cooker"
        name="cooker"
        value={accessory.cooker}
        onChange={handleAccessoryChange}
      />
    </div>
  );
};

export default Accessory;
